import { Section, SelectorIdentifier } from '../../models';
import { RainSensorFieldIds, RainSectionIds } from './base-config-models';
import { field } from '../../core/field-schema';
import { pattern } from '../../core/validator-builders';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { MonitoringPointElement } from '../../../models/location-card.model';
import { RainAlertLocationCardState } from './models';
import { roundToDecimal } from '../../models/utils';

/**
 * Rain Sensor Configuration Section
 */
export const rainSensor = (state: RainAlertLocationCardState): Section => {
    const config = state.monitorConfiguration;
    const isMetric = state.settings.isMetric;

    return {
        info: {
            id: RainSectionIds.RainSensor,
            title: 'ADD_EDIT.RAIN',
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: !state.permissions.isMonitorEditor
                ? 'surface-combo-section disable-field'
                : 'surface-combo-section',
        },
        rows: [
            // Rain Per Tip and Data Log Mode row
            {
                info: {
                    id: 'rain-sensor-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.number(RainSensorFieldIds.RainPerTip, 'rainpertip', {
                        placeholder: 'ADD_EDIT.RAIN_PER_TIP',
                        panelClass: 'each-Item',
                        value: roundToDecimal(config?.rainpertip, isMetric ? 3 : 2) ?? (isMetric ? 0.254 : 0.01),
                        decimalPlaces: isMetric ? 3 : 2,
                        validators: [
                            pattern({
                                value: isMetric
                                    ? REGEX_CONFIG.numeric0_100000With3DecimalPlacesPattern
                                    : REGEX_CONFIG.numeric0_100000With2DecimalPlacesPattern,
                                message: isMetric
                                    ? 'COMMON.NUMERIC_PRECISION_ERROR_3_DECIMALS'
                                    : 'COMMON.NUMERIC_PRECISION_ERROR',
                            }),
                        ],
                    }),
                    field.select<MonitoringPointElement, number>(RainSensorFieldIds.DataLogMode, 'datalogmode', {
                        placeholder: 'ADD_EDIT.DATA_LOG_MODE',
                        panelClass: 'each-Item',
                        value: config?.datalogmode ?? 0,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        optionsSelector: SelectorIdentifier.DataLogModeOptions,
                    }),
                ],
            },
        ],
    };
};
